<script>
  /**
   * @type {string}
   */
  export let color = "#0000";
  export let size = 40;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  height={size}
  viewBox="0 -960 960 960"
  width={size}
>
  <path d="M40-120L480-880L920-120H40Z" fill={color} />
  <path d="M144-180H816L480-760L144-180Z" fill="none" />
  <path
    d="M505.5-245.68Q514-254.35 514-267.18Q514-280 505.32-288.5Q496.65-297 483.82-297Q471-297 462.5-288.32Q454-279.65 454-266.82Q454-254 462.68-245.5Q471.35-237 484.18-237Q497-237 505.5-245.68Z"
    fill="#fff"
  />
  <rect x="454" y="-572" width="60" height="224" fill="#fff" />
</svg>
